// Libraries
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

// Components
import { TextDescription } from './pages/StageOne/WrapFormContent'

export const ContentWrap = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  ${({ theme }) => css`
    max-width: ${theme.maxWidth};
    ${theme.media.desktop} {
      max-width: ${theme.maxWidthDesktop};
    }
    ${theme.media.laptop} {
      max-width: ${theme.maxWidthLaptop};
    }
    ${theme.media.laptopS} {
      max-width: ${theme.maxWidthLaptopS};
    }
    ${theme.media.tablet} {
      max-width: ${theme.maxWidthTablet};
    }
    ${theme.media.mobileL} {
      max-width: ${theme.maxWidthMobileL};
    }
    ${theme.media.mobileM} {
      max-width: ${theme.maxWidthMobileM};
    }
    ${theme.media.mobileS} {
      max-width: ${theme.maxWidthMobileS};
    }
    ${theme.media.mobileXS} {
      max-width: ${theme.maxWidthMobileXS};
    }
  `}
`;

export const FullHeight = styled(ContentWrap)`
  min-height: 100vh;
  align-items: center;
`;

export const FullHeightFlex = styled(FullHeight)`
  display: flex;
  justify-content: space-between;
`;

export const Main = styled.main`
  background-image: url("/background.avif");
  background-position: 50% 50%;
  background-size: cover;
  overflow-x: hidden;
`;

export const Ship = styled(motion.img)`
  z-index: 0;
  position: absolute;
  bottom: 0;
  right: 0;
  height: 343px;
  width: 191px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  row-gap: 20px;
  text-align: left;
  width: 420px;
  ${({ theme }) => css`
    ${theme.media.mobileL} {
      width: 100%;
    }
  `}
`;

export const VerticalLineFantom = styled.div`
  display: inline-block;
  height: 142px;
  width: 4px;
  background-color: #ffe600;
  ${({ theme }) => css`
    ${theme.media.desktop} {
      height: 120px;
    }
    ${theme.media.tablet} {
      height: 100px;
    }
    ${theme.media.mobileL} {
      display: none;
    }
  `}
`;

export  const BorderedWrap = styled.div`
  position: relative;
  width: 420px;
  display: flex;
  align-self: center;
  margin: 220px 0 20px 0;
  padding: 72px 33px 29px 33px;
  border: 1px solid #fff;  
  box-sizing: border-box;
  ${({ theme }) => css`
    ${theme.media.tablet} {
      width: 95%;
    }
  `}
`;

export const BookClosedAbsolute = styled.img`
  position: absolute;
  width: 195px;
  height: 288px;
  top: -205px;
  left: 50%;
  transform: translateX(-50%);
`;

export const TextDescriptionCenter = styled.p`
  font-family: "Avenir Next Regular", sans-serif;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
`;

export const EndingTitle = styled.h2`
  font-family: "Avenir Next Regular", sans-serif;
  font-weight: 500;
  font-size: 48px;
  line-height: 66px;
  color: #ffe600;
  text-align: center;
  ${({ theme }) => css`
    ${theme.media.tablet} {
      font-size: 32px;
      line-height: 44px;
    }
  `}
`;

export const WrapImg = styled.div`
  width: 102px;
  height: 102px;
  border: 1px solid #fff;
  ${({ theme }) => css`
    ${theme.media.tablet} {
      margin-bottom: 15px;
    }
  `}
`;

export const Contacts = styled.div`
  background-color: #1994D8;
`;

export const TextDescriptionFinalPage = styled(TextDescription)`
  margin: 0 0 0 17px;
`;

export const Absolute = styled.p`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

export const LinkHomePage = styled.a`
  display: flex;
  justify-content: center;
  align-self: center;
  align-items: center;
  width: 421px;
  height: 70px;
  margin: 0 0 10px 0;
  font-family: "Avenir Next Regular", sans-serif;
  font-size: 28px;
  line-height: 38px;
  border: none;
  color: #fff;
  background-color: #ea3639;
  box-shadow: 8px 8px 8px rgba(36, 36, 36, 0.4);
  z-index: 1;
  user-select: none;
  :hover {
    background-color: #ec080b;
    cursor: pointer;
  }
  :active {
    background-color: #ec080b;
  }
  ${({theme}) => css`
    ${theme.media.tablet} {
      width: 100%;
    }
  `}
`;
